export const MuiLinearProgress = {
  styleOverrides: {
    barColorPrimary: {
      backgroundColor: '#3074e1',
    },
  },
}
